import { TableCardStyle } from "components/TableCard/TableCard.style";
import { format } from "date-fns";

interface SentFaxCardTableType {
  action: string;
  email: string;
  ipAddress: string;
  timestamp: string;
}

interface SentFaxCardTableProps {
  sentFaxData: SentFaxCardTableType[];
}

const SentFaxCardTable = ({ sentFaxData }: SentFaxCardTableProps) => {
  return (
    <>
      {sentFaxData?.length > 0 &&
        sentFaxData?.map((fax) => (
          <TableCardStyle key={fax?.timestamp}>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <div className="to-number">
                {format(new Date(fax?.timestamp), "M-d-yyyy, hh:mm a") ?? ""}
              </div>
              <div className="to-number">{fax?.action}</div>
            </div>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <div className="from-number">{fax?.email}</div>
              <div className="date">{fax?.ipAddress}</div>
            </div>
          </TableCardStyle>
        ))}
    </>
  );
};

export default SentFaxCardTable;
